export interface Volume {
  number: string
  title: string
  subtitle: string
  description: string
  items: string[]
  note?: string
}

export const volumes: Volume[] = [
  {
    number: 'VOLUME 1',
    title: 'THE CASE COMMAND CENTER™',
    subtitle: 'Build Your Case Dashboard Before You Start',
    description:
      'Create a structured overview of the case so the important information, resources, documents, and review points have a clear place.',
    items: [
      'Master Case Dashboard',
      'Case Overview Sheet',
      'Case Information Organizer',
      'Case Journey Map',
      'Case Status Tracker',
      'Records Organization Sheet',
      'Case Preparation Worksheet',
      'Master Case Summary',
    ],
  },
  {
    number: 'VOLUME 2',
    title: 'THE PLANNING CONTROL BOARD™',
    subtitle: 'Organize Your Digital Planning Review',
    description: 'Turn scattered planning notes into a structured visual review process.',
    items: [
      'Planning Review Board',
      'Digital Planning Organizer',
      'Case Review Map',
      'Planning Notes Sheet',
      'Movement Review Organizer',
      'Treatment Planning Tracker',
      'Pre-Approval Review Sheet',
      'Planning Summary',
    ],
    note: 'Educational organizational tools only. Clinical decisions remain the responsibility of the treating professional.',
  },
  {
    number: 'VOLUME 3',
    title: 'THE INSTALLATION COMMAND SYSTEM™',
    subtitle: 'Prepare Your Appointment Without Relying On Memory',
    description:
      'Create a repeatable organization system for the information, materials, patient communication, documentation, and review points surrounding an installation appointment.',
    items: [
      'Pre-Installation Command Sheet',
      'Appointment Preparation Checklist',
      'Delivery Organization Sheet',
      'Patient Instruction Organizer',
      'Documentation Tracker',
      'Installation Quick Reference',
      'Appointment Notes',
      'Post-Appointment Review Sheet',
    ],
  },
  {
    number: 'VOLUME 4',
    title: 'THE ATTACHMENT & IPR CONTROL CENTER™',
    subtitle: 'Keep Procedure-Related Information Organized In One Place',
    description:
      'Organize the information and documentation surrounding attachments and IPR-related stages of an aligner case.',
    items: [
      'Attachment Organization Board',
      'Attachment Checklist',
      'Material Preparation Sheet',
      'IPR Planning Organizer',
      'IPR Documentation Sheet',
      'Pre-Procedure Organization Checklist',
      'Post-Procedure Review',
      'Quick Reference Cards',
    ],
    note: 'Always apply professional judgment, training, manufacturer instructions, and applicable clinical regulations.',
  },
  {
    number: 'VOLUME 5',
    title: 'THE CASE PROGRESS COMMAND CENTER™',
    subtitle: 'Track The Case From Appointment To Appointment',
    description:
      'Create a visual history of the case so you can quickly understand what has happened, what has been documented, and what needs to be reviewed.',
    items: [
      'Patient Progress Tracker',
      'Appointment Timeline',
      'Follow-Up Organizer',
      'Case Control Sheet',
      'Documentation Tracker',
      'Progress Monitoring Sheet',
      'Case History',
      'Review Questions',
      'Case Status Dashboard',
    ],
  },
  {
    number: 'VOLUME 6',
    title: 'THE REFINEMENT & FINISHING COMMAND CENTER™',
    subtitle: 'Organize The Final Stages Without Rebuilding The Case From Scratch',
    description:
      'Keep reassessment, refinement, finishing, completion, and case documentation organized inside the same system.',
    items: [
      'Reassessment Organizer',
      'Refinement Review Board',
      'Refinement Checklist',
      'Case History Summary',
      'Finishing Organization Sheet',
      'Final Documentation Sheet',
      'Treatment Completion Review',
      'Retention Planning Organizer',
      'Final Case Summary',
    ],
  },
]
